/**
 * Eigenbau: Schalter des Entwurfs — Tremors Switch ist eine Rundpille.
 *
 * Der Entwurf zeichnet den Schalter als Rechteck: 36×19px, der Knopf 15×15px
 * in Papierfarbe, das Feld in `--schalter` (aus) oder `--tinte` (an). Keine
 * Rundung, kein Label im Feld — die Beschriftung steht daneben und gehört dem
 * Aufrufer.
 *
 * `aria-pressed` statt `role="switch"`, weil der Entwurf ihn überall als
 * Zweitzustand einer Zeile nutzt; die Beschriftung liefert der Kontext.
 */

import { cx, focusRing } from "@/lib/utils";

export function Schalter({
  an,
  onKlick,
  ariaLabel,
  disabled = false,
  className,
}: {
  an: boolean;
  onKlick?: () => void;
  ariaLabel: string;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={an}
      aria-label={ariaLabel}
      onClick={onKlick}
      disabled={disabled}
      className={cx(
        "flex h-[19px] w-9 flex-none cursor-pointer items-center p-0.5 transition-colors duration-150 ease-aus",
        an ? "justify-end bg-tinte" : "justify-start bg-schalter",
        "disabled:cursor-not-allowed disabled:opacity-40",
        focusRing,
        className,
      )}
    >
      <span className="block size-[15px] bg-papier" aria-hidden="true" />
    </button>
  );
}
